import React, { FC } from 'react'
import ControlledTextArea from 'transfix-form/components/ControlledTextArea'
import { DISPLAY } from 'constants/display'
import InlineEditDisplay from './InlineEditDisplay'
import { TOnSubmitField } from './types'

interface ITextSummaryProps {
  value?: string | null
  onChange: TOnSubmitField
  readOnly?: boolean
}

/**
 * Issue summary details
 */
export const TextSummary: FC<ITextSummaryProps> = ({ onChange, readOnly, value }) => (
  <InlineEditDisplay
    name='summary'
    dataTest='summary-edit'
    label='Summary'
    displayValue={value || DISPLAY.emptyDash}
    readOnly={readOnly}
    onSubmit={onChange}>
    <ControlledTextArea
      name='summary'
      defaultValue={value}
      TextAreaProps={{
        placeholder: 'Add summary...',
        size: 'medium',
        dataTest: 'issue-summary',
      }}
    />
  </InlineEditDisplay>
)

export default TextSummary
